import React, { useCallback } from "react";
import { Dropdown, IconButton, Button } from "@alm/flow-ds/components";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getCheckedBoxes } from "data/app/appSelectors";
import { useSelector } from "react-redux";

interface Props {
	changePriority?: (event: React.SyntheticEvent<HTMLButtonElement>) => void;
	unassignTask?: () => void;
	id?: string;
	prioritySet: boolean;
	canBeReassigned: boolean;
	canBeUnassigned?: boolean;
	canDeleteActivity?: boolean;
	canBeClaimed?: boolean;
	isDisabled?: boolean;
	loading?: boolean;
	deleteActivity?: () => void;
	onReadUnread?: () => void;
	claimTask?: () => void;
}

export default function TaskMenu({
	changePriority,
	unassignTask,
	id,
	prioritySet,
	canBeReassigned,
	canBeUnassigned,
	canDeleteActivity,
	canBeClaimed,
	isDisabled = false,
	loading,
	deleteActivity,
	onReadUnread,
	claimTask,
}: Props) {
	const { t } = useTranslation();

	const history = useHistory();

	const checkboxes = useSelector(getCheckedBoxes);

	const handleOnDeleteClick = useCallback(() => {
		history.push(`/tasks/my-tasks?deleteId=${id}`);
	}, [history, id]);

	const isRowSelected = id && checkboxes.includes(id);
	let claimLabel = t("main.tasks.labels.claim");

	if (isRowSelected || id === undefined) {
		const selectedCount = checkboxes.length;
		claimLabel += ` (${selectedCount})`;
	}

	return (
		<>
			<Dropdown
				id={`taskMenu__dropdown__${id}`}
				disabled={isDisabled || loading ? true : false}
				menuBtn={
					<IconButton
						className="btn-basic--dark"
						icon="ellipsis-v"
						label={t("main.labels.menu")}
					/>
				}
				align="right">
				{canBeClaimed && (
					<Button
						name="claimTask"
						label={claimLabel}
						className="dropdown-item btn-basic--default"
						onClick={claimTask}
					/>
				)}
				{!(checkboxes.length > 0) && (
					<>
						<Button
							name="highPriority"
							label={t("main.tasks.labels.HIGH")}
							className="dropdown-item btn-basic--default"
							value="HIGH"
							onClick={changePriority}
						/>
						<Button
							name="lowPriority"
							label={t("main.tasks.labels.LOW")}
							className="dropdown-item btn-basic--default"
							value="LOW"
							onClick={changePriority}
						/>
						{prioritySet && (
							<Button
								name="removePriority"
								label={t("main.tasks.labels.removePriority")}
								className="dropdown-item btn-basic--default"
								onClick={changePriority}
								value="NORMAL"
							/>
						)}
					</>
				)}
				{canBeReassigned && (
					<Button
						name="reassignTask"
						label={t("main.tasks.labels.reassignTask")}
						className="dropdown-item btn-basic--default"
						onClick={() =>
							history.push(`/tasks/my-tasks?reassign=${id}`)
						}
					/>
				)}
				{canBeUnassigned && (
					<Button
						name="unassignTask"
						label={t("main.tasks.labels.unassignTask")}
						className="dropdown-item btn-basic--default"
						onClick={unassignTask}
					/>
				)}
				{canDeleteActivity && (
					<Button
						name="deleteActivity"
						label={t("main.tasks.labels.deleteActivity")}
						className="dropdown-item btn-basic--default"
						onClick={handleOnDeleteClick}
					/>
				)}
				{onReadUnread && (
					<Button
						name="readUnread"
						label={`Toggle read status`}
						className="dropdown-item btn-basic--default"
						onClick={onReadUnread}
					/>
				)}
			</Dropdown>
		</>
	);
}
